import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { registerUser } from '../api';

export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    try {
      await registerUser(email, password, displayName);
      setSuccess(true);
      setTimeout(() => navigate('/login'), 1200);
    } catch (err) {
      setError(err.message || 'Registration failed');
    }
  };

  return (
    <div className="auth-container">
      <h2>Register</h2>
      <form onSubmit={handleSubmit}>
        <label>Email</label>
        <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
        <label>Password</label>
        <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
        <label>Display Name</label>
        <input type="text" value={displayName} onChange={e => setDisplayName(e.target.value)} required />
        <button type="submit">Register</button>
        {error && <div className="error">{error}</div>}
        {success && <div className="success">Registration successful! Redirecting...</div>}
      </form>
      <div style={{marginTop: 12}}>
        <Link to="/login">Already have an account? Login</Link>
      </div>
    </div>
  );
}
